.tab {
    display: flex;
    padding: 16px 4px;
    justify-content: center;
    align-items: center;
    gap: 8px;
    height: 100%;
    border-bottom: 2px solid transparent;
}

.tab--less-padding {
    padding: 8px 4px;
}

.tab:hover {
    border-bottom: 2px solid var(--off-white-dk);
    background: var(--off-white);
}

/* Backup for browsers that do not support :focus-visible */
.tab:focus {
    background-color: var(--off-white);
    outline: var(--blue) solid 1px;
    outline-offset: 0;
    border-radius: 4px;
}

/* Removes focus style on non-keyboard input (i.e. mouse click) */
.tab:focus:not(:focus-visible) {
    outline: none;
    background-color: var(--white);
    border-radius: 0;
}

/* Adds focus style only on keyboard input for browsers that support :focus-visible */
.tab:focus-visible {
    background-color: var(--off-white);
    outline: var(--blue) solid 1px;
    outline-offset: 0;
    border-radius: 4px;
}

.tab--selected {
    composes: tab;
    border-bottom: 2px solid var(--blue);
    border-radius: 0;
}

.tab--selected:hover {
    border-bottom: 2px solid var(--blue);
    background: var(--off-white);
}

.tab--selected-ai {
    composes: tab;
    border-bottom: 2px solid var(--ai-purple-primary);
    border-radius: 0;
}

.tab--selected-ai:hover {
    border-bottom: 2px solid var(--ai-purple-primary);
    background: var(--ai-purple-bg);
}
